/* ========================================================================
   THE BEAUTY METHOD — Theme JS v2
   ======================================================================== */
(function() {
  'use strict';


  /* ==================== SCROLL ANCRES HERO ==================== */
  function initHeroScrolls() {
    var feedBtn = document.querySelector('.hero-cta-feed');
    if (feedBtn) {
      feedBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById('miniquiz');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
    var quizBtn = document.querySelector('.hero-cta-quiz');
    if (quizBtn) {
      quizBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById('business-quiz');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  /* ==================== MENU MOBILE ==================== */
  function initMobileMenu() {
    var burger = document.getElementById('siteBurger') || document.querySelector('[data-burger]');
    var mobileMenu = document.getElementById('mobileMenu') || document.querySelector('[data-mobile-menu]');
    var closeBtn = document.getElementById('mobileMenuClose') || document.querySelector('[data-mobile-close]');
    if (!burger || !mobileMenu) return;

    function openMenu() {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    burger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', closeMenu);
    });
    // Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  /* ==================== QUIZ PRINCIPAL ==================== */

  function initQuiz() {
    var overlay = document.querySelector('[data-quiz-overlay]');
    if (!overlay) return;

    var box = overlay.querySelector('[data-quiz-box]');
    var progressBar = overlay.querySelector('[data-quiz-progress]');
    var screens = overlay.querySelectorAll('[data-quiz-screen]');
    var closeBtn = overlay.querySelector('[data-quiz-close]');
    var openTriggers = document.querySelectorAll('[data-quiz-open]');

    var state = { path: null, answers: {}, history: ['welcome'] };

    function openQuiz() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      showScreen('welcome');
      state = { path: null, answers: {}, history: ['welcome'] };
      updateProgress(0);
    }
    function closeQuiz() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    function showScreen(name) {
      screens.forEach(function(s) {
        s.classList.toggle('active', s.dataset.quizScreen === name);
      });
      if (box) box.scrollTop = 0;
    }
    function updateProgress(percent) {
      if (progressBar) progressBar.style.width = percent + '%';
    }

    openTriggers.forEach(function(t) {
      t.addEventListener('click', function(e) {
        e.preventDefault();
        openQuiz();
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', closeQuiz);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeQuiz();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeQuiz();
    });

    overlay.querySelectorAll('[data-quiz-path]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var path = btn.dataset.quizPath;
        state.path = path;
        state.answers = {};
        state.history = ['welcome', 'q0', path + '1'];
        showScreen(path + '1');
        updateProgress(15);
      });
    });

    overlay.querySelectorAll('[data-quiz-answer]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var screen = btn.closest('[data-quiz-screen]');
        var screenName = screen.dataset.quizScreen;
        var answerKey = btn.dataset.quizAnswer;
        state.answers[screenName] = answerKey;

        var nextScreen = btn.dataset.quizNext;
        if (nextScreen === 'result') { showResult(); return; }

        state.history.push(nextScreen);
        showScreen(nextScreen);
        var QORDER = ['q0','q1','q2','q4','q9','q13'];
        updateProgress((QORDER.indexOf(nextScreen) / QORDER.length) * 100);
      });
    });

    overlay.querySelectorAll('[data-quiz-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (state.history.length > 1) {
          state.history.pop();
          var prev = state.history[state.history.length - 1];
          showScreen(prev);
          if (prev === 'welcome' || prev === 'q0') updateProgress(0);
          else {
            var QO = ['q0','q1','q2','q4','q9','q13'];
            updateProgress((QO.indexOf(prev) / QO.length) * 100);
          }
        }
      });
    });

    overlay.querySelectorAll('[data-quiz-restart]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        state = { path: null, answers: {}, history: ['welcome'] };
        showScreen('welcome');
        updateProgress(0);
      });
    });

    function showResult() {
      var p = composePotentiel(state.answers);
      var resultEl = overlay.querySelector('[data-quiz-result]');
      if (!resultEl) return;

      resultEl.innerHTML =
        '<div class="quiz-result-card">' +
          '<span class="quiz-badge">Ton potentiel de formation</span>' +
          '<h3>' + esc(p.specialite) + '</h3>' +
          (p.intro ? '<p>' + esc(p.intro) + '</p>' : '') +
          '<div class="quiz-result-grid">' +
            '<div><strong>Expertise la plus monétisable</strong><span>' + esc(p.monetisable) + '</span></div>' +
            '<div><strong>Format à explorer</strong><span>' + esc(p.format) + '</span></div>' +
            '<div><strong>Ce qu\'il te manque</strong><span>' + esc(p.manque) + '</span></div>' +
          '</div>' +
          (p.warning ? '<p class="quiz-result-warning">' + esc(p.warning) + '</p>' : '') +
        '</div>' +
        '<div class="quiz-name-card">' +
          '<span class="quiz-badge">Ta formation pourrait s\'appeler</span>' +
          '<h3>' + esc(p.formationName) + '</h3>' +
          '<span class="quiz-name-niveau">' + esc(p.formationNiveau) + '</span>' +
        '</div>' +
        '<a href="https://thebeautymethod.fr/products/devenir-formatrice-accompagnement" class="btn btn-primary btn-block">Découvrir Devenir Formatrice →</a>' +
        '<a href="https://wa.me/33751723457" class="quiz-whatsapp-link" target="_blank" rel="noopener">J\'ai une question → WhatsApp</a>' +
        '<button type="button" class="quiz-secondary-link" data-quiz-close-result>Voir le site</button>';

      var closeResult = resultEl.querySelector('[data-quiz-close-result]');
      if (closeResult) closeResult.addEventListener('click', closeQuiz);

      showScreen('result');
      updateProgress(100);
    }
  }

  function composePotentiel(answers) {
    var SPECIALITE = {
      q0a: "Makeup & maquillage", q0b: "Cils & sourcils", q0c: "Onglerie", q0d: "Coiffure & expertise capillaire",
      q0e: "Skincare & conseil beauté", q0f: "Bien-être", q0g: "Parfumerie & expertise produit",
      q0h: "Image & conseil beauté", q0i: "Ta spécialité beauté"
    };
    var MONETISABLE = {
      q4a: "Ta technique personnelle, c'est ce qui te différenciera le plus dans ta future formation.",
      q4b: "Ton approche client et l'expérience que tu proposes, rare et difficile à copier.",
      q4c: "Ta rapidité et ton efficacité, un vrai argument pour une formation courte et concrète.",
      q4d: "On le trouve ensemble pendant l'accompagnement, à partir de ce que tu fais déjà."
    };
    var LIEU = { q9a: "présentiel", q9b: "en ligne", q9c: "présentiel et en ligne", q9d: "à définir" };
    var GROUPE = { q10a: "en groupe", q10b: "en individuel", q10c: "groupe ou individuel selon les cas", q10d: "" };
    var MANQUE = {
      q13a: "Structurer ta méthode", q13b: "Créer ton programme", q13c: "Créer tes supports", q13d: "Savoir combien vendre"
    };
    var REGULATED = { q0e: true, q0f: true };

    var PREFIX = {
      q0a: "Masterclass Makeup", q0b: "L'Art du Regard", q0c: "Signature Onglerie",
      q0d: "Académie Capillaire", q0e: "Le Rituel Skincare", q0f: "L'École du Bien-être",
      q0g: "L'Atelier Parfum", q0h: "Le Studio Image", q0i: "Ta Méthode Signature"
    };
    var ANGLE = {
      q4a: "Édition Technique", q4b: "Édition Expérience", q4c: "Édition Express", q4d: "Édition Sur-Mesure"
    };
    var NIVEAU = {
      q2a: "niveau découverte", q2b: "niveau initiée", q2c: "niveau confirmée", q2d: "niveau expertise"
    };
    var formationName = (PREFIX[answers.q0] || PREFIX.q0i) + " · " + (ANGLE[answers.q4] || ANGLE.q4d);
    var formationNiveau = NIVEAU[answers.q2] || NIVEAU.q2b;

    var specialite = SPECIALITE[answers.q0] || SPECIALITE.q0i;
    var monetisable = MONETISABLE[answers.q4] || MONETISABLE.q4d;
    var lieu = LIEU[answers.q9] || LIEU.q9d;
    var groupe = GROUPE[answers.q10] || '';
    var format = groupe ? (lieu + ', ' + groupe) : lieu;
    var manque = MANQUE[answers.q13] || "Structurer ta méthode, ton programme et tes supports";
    var warning = null;
    if (REGULATED[answers.q0] && answers.q1 === 'q1c') {
      warning = "Certaines prestations de soin ou de bien-être nécessitent une qualification professionnelle pour être exercées et enseignées légalement. On en parle ensemble avant de construire ta formation.";
    }
    return { specialite: specialite, monetisable: monetisable, format: format, manque: manque, warning: warning, formationName: formationName, formationNiveau: formationNiveau };
  }

  // Total questions par chemin (v2 : enrichi)

  function esc(str) {
    if (str == null) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ==================== MINI QUIZ FEED INSTAGRAM ==================== */
  /* 100% tuiles graphiques (pas de photos), styles variés rendus avec les 2 couleurs choisies */
  window.FEED_DATA = {
    jobs: {
      'lash': {
        label: 'Lash artiste',
        handle: '@tonpseudo.cils',
        tagline: 'Cils volume & extensions, sur RDV',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8136.jpg?v=1777285135',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8130.jpg?v=1777285136'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'Après' },
          { kind: 'numbered', num: '01', title: 'Volume russe', sub: 'Tendance signature' },
          { kind: 'quote', title: '"Magique"', sub: 'Inès, cliente' },
          { kind: 'typo', title: 'Cils', sub: 'volume' },
          { kind: 'price', title: '49€', sub: 'Pose simple' },
          { kind: 'pattern', title: 'En cabine', sub: 'Coulisses' },
          { kind: 'accent', title: 'Entretien', sub: 'Mes conseils' },
          { kind: 'numbered', num: '02', title: 'Mega volume', sub: 'Effet glamour' },
          { kind: 'cta', title: 'Réserver', sub: 'DM ouverts' }
        ],
        feedTitles: ['Volume russe', 'Pose simple', 'Cils naturels', 'Avant Apres', 'Mega volume', 'Conseils entretien', 'Coulisses cabine', 'Tarifs', 'Réservation'],
        reels: ['POV première pose', 'Avant Après cils', '3 erreurs sur tes cils', 'Routine entretien', 'Behind the scenes', 'Choisir son volume']
      },
      'ongles': {
        label: 'Prothésiste ongulaire',
        handle: '@tonpseudo.nails',
        tagline: 'Pose & nail art, sur RDV',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8152.jpg?v=1777285135',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8150.jpg?v=1777285136'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'Après' },
          { kind: 'typo', title: 'Nail', sub: 'art' },
          { kind: 'numbered', num: '01', title: 'Pose résine', sub: 'Tenue 3 semaines' },
          { kind: 'quote', title: '"Trop belles"', sub: 'Sarah, cliente' },
          { kind: 'price', title: '55€', sub: 'Pose complète' },
          { kind: 'accent', title: 'Tendance', sub: 'Du moment' },
          { kind: 'pattern', title: 'Détail', sub: 'finition' },
          { kind: 'numbered', num: '02', title: 'Soin ongles', sub: 'Routine pro' },
          { kind: 'cta', title: 'Réserver', sub: 'Place limitée' }
        ],
        feedTitles: ['Pose résine', 'Nail art', 'French moderne', 'Avant Apres', 'Soin ongles', 'Tarifs', 'En cabine', 'Tendance', 'Réserver'],
        reels: ['POV pose semi-perm', 'Avant Après ongles', '3 erreurs nail care', 'Tuto nail art', 'Behind the scenes', 'Choisir sa forme']
      },
      'maquillage': {
        label: 'Maquilleuse',
        handle: '@tonpseudo.mua',
        tagline: 'Mariée, soirée, shooting',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8155.jpg?v=1777285136',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8156.jpg?v=1777285135'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'Après' },
          { kind: 'typo', title: 'Make', sub: 'up' },
          { kind: 'numbered', num: '01', title: 'Maquillage mariée', sub: 'Service complet' },
          { kind: 'quote', title: '"Sublime"', sub: 'Camille, mariée' },
          { kind: 'price', title: '180€', sub: 'Forfait mariée' },
          { kind: 'accent', title: 'Glow', sub: 'naturel' },
          { kind: 'pattern', title: 'Mon kit', sub: 'pro' },
          { kind: 'numbered', num: '02', title: 'Maquillage soirée', sub: 'Effet wow' },
          { kind: 'cta', title: 'Essai', sub: 'Sur RDV' }
        ],
        feedTitles: ['Maquillage mariée', 'Make up soirée', 'Glow naturel', 'Avant Apres', 'Mon kit pro', 'Forfait', 'Coulisses', 'Astuce make up', 'Réserver'],
        reels: ['POV maquillage mariée', 'Avant Après glow', '3 erreurs make up', 'Routine maquillage', 'Behind the scenes', 'Mon kit favoris']
      },
      'brow': {
        label: 'Brow artiste',
        handle: '@tonpseudo.sourcils',
        tagline: 'Restructuration & brow lift',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8138.jpg?v=1777285136',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8139.jpg?v=1777285135'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'Après' },
          { kind: 'typo', title: 'Brow', sub: 'lift' },
          { kind: 'numbered', num: '01', title: 'Forme parfaite', sub: 'Selon ton visage' },
          { kind: 'quote', title: '"Naturel"', sub: 'Léa, cliente' },
          { kind: 'price', title: '45€', sub: 'Restructuration' },
          { kind: 'accent', title: 'Étape', sub: 'par étape' },
          { kind: 'pattern', title: 'En cabine', sub: 'Coulisses' },
          { kind: 'numbered', num: '02', title: 'Erreurs', sub: 'à éviter' },
          { kind: 'cta', title: 'Réserver', sub: 'DM ouverts' }
        ],
        feedTitles: ['Brow lift', 'Forme parfaite', 'Restructuration', 'Avant Apres', 'Tarifs', 'En cabine', 'Tuto sourcils', 'Erreurs', 'Réserver'],
        reels: ['POV brow lift', 'Avant Après sourcils', '3 erreurs sourcils', 'Tuto forme parfaite', 'Behind the scenes', 'Choisir sa forme']
      },
      'esthetique': {
        label: 'Esthéticienne',
        handle: '@tonpseudo.skin',
        tagline: 'Soins visage & corps, institut',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8168.jpg?v=1777285135',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8169.jpg?v=1777285135'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'Après' },
          { kind: 'typo', title: 'Glow', sub: 'soin' },
          { kind: 'numbered', num: '01', title: 'Soin signature', sub: 'Visage 60 min' },
          { kind: 'quote', title: '"Peau neuve"', sub: 'Myriam, cliente' },
          { kind: 'price', title: '85€', sub: 'Soin signature' },
          { kind: 'accent', title: 'Routine', sub: 'maison' },
          { kind: 'pattern', title: 'Mes', sub: 'produits' },
          { kind: 'numbered', num: '02', title: 'Carte', sub: 'des soins' },
          { kind: 'cta', title: 'Réserver', sub: 'un soin' }
        ],
        feedTitles: ['Soin visage', 'Avant Apres', 'Peau parfaite', 'Ritual glow', 'Drainage', 'Peeling', 'Soin corps', 'Gua sha', 'Massage facial'],
        reels: ['POV premier soin', '3 erreurs skincare', 'Avant Après peau', 'Routine du matin', 'Behind the scenes', 'Tuto gua sha']
      },
      'coiffure': {
        label: 'Coiffeuse',
        handle: '@tonpseudo.hair',
        tagline: 'Coloration & coupes, salon',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8166.jpg?v=1777285137',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8163.jpg?v=1777285136'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'Après' },
          { kind: 'typo', title: 'Hair', sub: 'transfo' },
          { kind: 'numbered', num: '01', title: 'Balayage', sub: 'Lumineux' },
          { kind: 'quote', title: '"Bluffée"', sub: 'Jade, cliente' },
          { kind: 'price', title: '120€', sub: 'Coupe + couleur' },
          { kind: 'accent', title: 'Tendance', sub: 'saison' },
          { kind: 'pattern', title: 'En', sub: 'salon' },
          { kind: 'numbered', num: '02', title: 'Conseils', sub: 'entretien' },
          { kind: 'cta', title: 'Prendre RDV', sub: 'Salon ou domicile' }
        ],
        feedTitles: ['Balayage', 'Coupe signature', 'Coloration', 'Avant Apres', 'Soin cheveux', 'Tarifs', 'En salon', 'Tendance saison', 'Réserver'],
        reels: ['POV balayage', 'Avant Après cheveux', '3 erreurs coloration', 'Tuto coiffage', 'Behind the scenes', 'Routine cheveux']
      },
      'formatrice': {
        label: 'Formatrice',
        handle: '@tonpseudo.formation',
        tagline: 'Formations beauté certifiantes',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8170.jpg?v=1777285135',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8173.jpg?v=1777285135'
        ],
        posts: [
          { kind: 'split', title: 'Élève', subtitle: 'Formée' },
          { kind: 'typo', title: 'Forma', sub: 'tion' },
          { kind: 'numbered', num: '01', title: 'Programme', sub: 'Module 1 à 5' },
          { kind: 'quote', title: '"Pro en 3 mois"', sub: 'Inès, élève' },
          { kind: 'price', title: '890€', sub: 'Formation complète' },
          { kind: 'accent', title: 'Livret', sub: 'personnalisé' },
          { kind: 'pattern', title: 'Coulisses', sub: 'cours' },
          { kind: 'numbered', num: '02', title: 'Prochaine', sub: 'session' },
          { kind: 'cta', title: 'Inscription', sub: 'Place limitée' }
        ],
        feedTitles: ['Programme', 'Module 1', 'Élève formée', 'Avant Apres', 'Livret personnalisé', 'Tarifs', 'Coulisses cours', 'Prochaine session', 'Inscription'],
        reels: ['POV première leçon', 'Témoignage élève', '3 erreurs débutante', 'Behind the scenes', 'Comment choisir', 'Méthode vs école']
      },
      'cosme': {
        label: 'Marque cosmétique',
        handle: '@tamarque.cosme',
        tagline: 'Skincare clean & effets visibles',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8176.jpg?v=1777285136',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8175.jpg?v=1777285134'
        ],
        posts: [
          { kind: 'split', title: 'Avant', subtitle: 'J30' },
          { kind: 'typo', title: 'Skin', sub: 'care' },
          { kind: 'numbered', num: '01', title: 'Sérum signature', sub: 'Best-seller' },
          { kind: 'quote', title: '"Texture rêve"', sub: 'Yasmine, cliente' },
          { kind: 'price', title: '39€', sub: 'Sérum 30 ml' },
          { kind: 'accent', title: 'Ingrédients', sub: 'Clean & actifs' },
          { kind: 'pattern', title: 'Routine', sub: '3 étapes' },
          { kind: 'numbered', num: '02', title: 'Nouveauté', sub: 'Crème jour' },
          { kind: 'cta', title: 'Shop', sub: 'Livraison 48h' }
        ],
        feedTitles: ['Sérum signature', 'Crème jour', 'Routine 3 étapes', 'Avant Apres', 'Ingrédients', 'Tarifs', 'Coulisses labo', 'Best-seller', 'Shop'],
        reels: ['POV unboxing', 'Avant Après peau', '3 erreurs skincare', 'Routine signature', 'Behind the scenes', 'Mes ingrédients']
      },
      'vetements': {
        label: 'Marque vêtements',
        handle: '@tamarque.studio',
        tagline: 'Pièces féminines & premium',
        photos: [
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8180.jpg?v=1777285135',
          'https://cdn.shopify.com/s/files/1/1005/5172/1307/files/IMG_8181.jpg?v=1777285136'
        ],
        posts: [
          { kind: 'split', title: 'Look', subtitle: 'Stylé' },
          { kind: 'typo', title: 'New', sub: 'drop' },
          { kind: 'numbered', num: '01', title: 'Le tailleur', sub: 'Pièce signature' },
          { kind: 'quote', title: '"Coupe parfaite"', sub: 'Chloé, cliente' },
          { kind: 'price', title: '149€', sub: 'Tailleur veste' },
          { kind: 'accent', title: 'Lookbook', sub: 'Saison' },
          { kind: 'pattern', title: 'Détails', sub: 'matière' },
          { kind: 'numbered', num: '02', title: 'Bestseller', sub: 'Restocké' },
          { kind: 'cta', title: 'Shop', sub: 'Tailles limitées' }
        ],
        feedTitles: ['New drop', 'Le tailleur', 'Bestseller', 'Lookbook', 'Détails matière', 'Tarifs', 'Coulisses atelier', 'Restock', 'Shop'],
        reels: ['POV nouvelle collection', 'Try on haul', '3 façons de styler', 'Behind the scenes', 'Comment choisir sa taille', 'Le making of']
      }
    },
    palettePages: [
      {
        label: 'Tons sobres & élégants',
        colors: [
          { hex: '#3E2723', name: 'Espresso' },
          { hex: '#8F2A3C', name: 'Bordeaux' },
          { hex: '#C9A0A8', name: 'Vieux rose' },
          { hex: '#F4C9D6', name: 'Rose poudré' },
          { hex: '#EDD5C0', name: 'Beige nude' },
          { hex: '#FDFAF8', name: 'Crème nude' },
          { hex: '#B08A6E', name: 'Taupe' },
          { hex: '#C9A876', name: 'Camel doré' },
          { hex: '#5C3D2E', name: 'Chocolat' },
          { hex: '#6B3A3A', name: 'Prune' },
          { hex: '#9B8EA8', name: 'Mauve' },
          { hex: '#6B8E6B', name: 'Sauge' },
          { hex: '#5B7FA6', name: 'Bleu ardoise' },
          { hex: '#1A2A3A', name: 'Marine' },
          { hex: '#2A1410', name: 'Noir doux' }
        ]
      },
      {
        label: 'Tons vifs & affirmés',
        colors: [
          { hex: '#FF3366', name: 'Rose fluo' },
          { hex: '#FF6B9D', name: 'Hot pink' },
          { hex: '#E91E8C', name: 'Fuchsia' },
          { hex: '#C0392B', name: 'Rouge vif' },
          { hex: '#8E44AD', name: 'Violet' },
          { hex: '#6C1A2A', name: 'Bordeaux profond' },
          { hex: '#FF7043', name: 'Corail fluo' },
          { hex: '#F39C12', name: 'Jaune doré' },
          { hex: '#27AE60', name: 'Vert émeraude' },
          { hex: '#16A085', name: 'Turquoise' },
          { hex: '#2980B9', name: 'Bleu vif' },
          { hex: '#D4614A', name: 'Terracotta' },
          { hex: '#B5384F', name: 'Rose profond' },
          { hex: '#7D3C98', name: 'Prune vif' },
          { hex: '#E74C3C', name: 'Rouge fraise' }
        ]
      }
    ],
    palette: [
      { hex: '#3E2723', name: 'Espresso' },
      { hex: '#B5384F', name: 'Rose CTA' },
      { hex: '#F4C9D6', name: 'Rose poudré' },
      { hex: '#FDFAF8', name: 'Crème nude' },
      { hex: '#EDD5C0', name: 'Beige nude' },
      { hex: '#C9A0A8', name: 'Vieux rose' },
      { hex: '#8F2A3C', name: 'Bordeaux rosé' },
      { hex: '#6B3A3A', name: 'Prune chaud' },
      { hex: '#5C3D2E', name: 'Brun chocolat' },
      { hex: '#C9A876', name: 'Camel doré' },
      { hex: '#D4A5A5', name: 'Rose pâle' },
      { hex: '#B08A6E', name: 'Taupe' },
      { hex: '#2A1410', name: 'Noir doux' },
      { hex: '#ECC8D2', name: 'Bordeaux poudré' },
      { hex: '#F9E8EC', name: 'Rose glacé' },
      { hex: '#FFFFFF', name: 'Blanc pur' }
    ]
  };

  function initMiniQuiz() {
    var section = document.querySelector('[data-miniquiz]');
    if (!section) return;

    var stepJob = section.querySelector('[data-mq-step="job"]');
    var stepColors = section.querySelector('[data-mq-step="colors"]');
    var stepResult = section.querySelector('[data-mq-step="result"]');
    var colorsContainer = section.querySelector('[data-mq-colors]');
    var counterEl = section.querySelector('[data-mq-counter]');
    var validateBtn = section.querySelector('[data-mq-validate]');
    var resultContainer = section.querySelector('[data-mq-result]');

    var selectedJob = null;
    var selectedColors = [];

    function showStep(name) {
      [stepJob, stepColors, stepResult].forEach(function(el) {
        if (el) el.classList.remove('active');
      });
      var target = section.querySelector('[data-mq-step="' + name + '"]');
      if (target) target.classList.add('active');
      try { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    // Construire les couleurs — page 1 par défaut
    var currentColorPage = 0;
    function buildColorPage(pageIdx) {
      if (!colorsContainer) return;
      colorsContainer.innerHTML = '';
      selectedColors = [];
      if (counterEl) counterEl.innerHTML = '<strong>0</strong> / 2 couleurs sélectionnées';
      if (validateBtn) validateBtn.disabled = true;
      var page = FEED_DATA.palettePages ? FEED_DATA.palettePages[pageIdx] : null;
      var colors = page ? page.colors : FEED_DATA.palette;
      // Label page
      var pageLabel = colorsContainer.parentNode.querySelector('.mq-page-label');
      if (!pageLabel) {
        pageLabel = document.createElement('p');
        pageLabel.className = 'mq-page-label miniquiz-subtext';
        colorsContainer.parentNode.insertBefore(pageLabel, colorsContainer);
      }
      pageLabel.textContent = page ? page.label : 'Choisis tes couleurs';
      // Bouton switch
      var switchBtn = colorsContainer.parentNode.querySelector('.mq-switch-btn');
      if (!switchBtn) {
        switchBtn = document.createElement('button');
        switchBtn.type = 'button';
        switchBtn.className = 'mq-switch-btn';
        colorsContainer.parentNode.insertBefore(switchBtn, colorsContainer.nextSibling);
      }
      var otherPage = FEED_DATA.palettePages ? FEED_DATA.palettePages[pageIdx === 0 ? 1 : 0] : null;
      switchBtn.textContent = pageIdx === 0 ? 'Voir les couleurs vives →' : '← Voir les tons sobres';
      switchBtn.onclick = function(e) {
        e.preventDefault();
        currentColorPage = pageIdx === 0 ? 1 : 0;
        buildColorPage(currentColorPage);
        attachColorEvents();
      };
      colors.forEach(function(c, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'miniquiz-color';
        btn.style.background = c.hex;
        btn.setAttribute('data-color-hex', c.hex);
        btn.setAttribute('data-color-name', c.name);
        btn.setAttribute('aria-label', c.name);
        btn.addEventListener('click', function() {
          var hex = this.getAttribute('data-color-hex');
          var idx = selectedColors.indexOf(hex);
          if (idx > -1) {
            selectedColors.splice(idx, 1);
            this.classList.remove('selected');
          } else {
            if (selectedColors.length >= 2) {
              // déselectionne le 1er
              var firstHex = selectedColors.shift();
              var prev = colorsContainer.querySelector('[data-color-hex="' + firstHex + '"]');
              if (prev) prev.classList.remove('selected');
            }
            selectedColors.push(hex);
            this.classList.add('selected');
          }
          updateCounter();
        });
        colorsContainer.appendChild(btn);
      });
    }

    function updateCounter() {
      if (counterEl) counterEl.innerHTML = '<strong>' + selectedColors.length + '</strong> / 2 couleurs sélectionnées';
      if (validateBtn) {
        if (selectedColors.length === 2) validateBtn.classList.add('is-active');
        else validateBtn.classList.remove('is-active');
      }
    }

    // Sélection métier
    section.querySelectorAll('[data-mq-job]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectedJob = this.dataset.mqJob;
        showStep('colors');
      });
    });

    // Validation couleurs
    if (validateBtn) {
      validateBtn.addEventListener('click', function() {
        if (selectedColors.length !== 2) return;
        renderFeed();
        showStep('result');
      });
    }

    // Restart
    section.querySelectorAll('[data-mq-restart]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectedJob = null;
        selectedColors = [];
        if (colorsContainer) {
          colorsContainer.querySelectorAll('.miniquiz-color').forEach(function(c) {
            c.classList.remove('selected');
          });
        }
        updateCounter();
        showStep('job');
      });
    });

    // Back to colors
    section.querySelectorAll('[data-mq-back-colors]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        showStep('colors');
      });
    });

    // Helper : choisir la bonne couleur de texte selon la luminosité du fond
    function textColorFor(hex) {
      if (!hex) return '#FFFFFF';
      var h = hex.replace('#', '');
      if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var r = parseInt(h.substr(0,2), 16);
      var g = parseInt(h.substr(2,2), 16);
      var b = parseInt(h.substr(4,2), 16);
      var luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
      return luminance > 0.6 ? '#3E2723' : '#FFFFFF';
    }

    // Génère une variante claire d'une couleur (mix avec blanc)
    function lighten(hex, amount) {
      var h = hex.replace('#', '');
      if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var r = parseInt(h.substr(0,2), 16);
      var g = parseInt(h.substr(2,2), 16);
      var b = parseInt(h.substr(4,2), 16);
      r = Math.round(r + (255 - r) * amount);
      g = Math.round(g + (255 - g) * amount);
      b = Math.round(b + (255 - b) * amount);
      var toHex = function(n) { var s = n.toString(16); return s.length === 1 ? '0' + s : s; };
      return '#' + toHex(r) + toHex(g) + toHex(b);
    }
    // Génère une variante plus foncée d'une couleur
    function darken(hex, amount) {
      var h = hex.replace('#', '');
      if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
      var r = parseInt(h.substr(0,2), 16);
      var g = parseInt(h.substr(2,2), 16);
      var b = parseInt(h.substr(4,2), 16);
      r = Math.round(r * (1 - amount));
      g = Math.round(g * (1 - amount));
      b = Math.round(b * (1 - amount));
      var toHex = function(n) { var s = n.toString(16); return s.length === 1 ? '0' + s : s; };
      return '#' + toHex(r) + toHex(g) + toHex(b);
    }

    function renderFeed() {
      if (!resultContainer || !selectedJob || selectedColors.length !== 2) return;
      var jobData = FEED_DATA.jobs[selectedJob];
      if (!jobData) return;

      var c1 = selectedColors[0];
      var c2 = selectedColors[1];
      var creme = '#FDFAF8';
      var espresso = '#3E2723';

      // Variantes claires et foncées pour avoir plus de couleurs dans le feed
      var c1Light = lighten(c1, 0.55);
      var c2Light = lighten(c2, 0.55);
      var c1Dark = darken(c1, 0.20);
      var c2Dark = darken(c2, 0.20);

      // Récupérer les noms des couleurs depuis la palette
      function getColorName(hex) {
        for (var i = 0; i < FEED_DATA.palette.length; i++) {
          if (FEED_DATA.palette[i].hex.toLowerCase() === hex.toLowerCase()) {
            return FEED_DATA.palette[i].name;
          }
        }
        return '';
      }
      var c1Name = getColorName(c1);
      var c2Name = getColorName(c2);

      // Titres
      var titles = (jobData.feedTitles || jobData.posts.map(function(p) { return p.title || p.kind; })).slice(0, 9);
      // Photos du métier (2 photos)
      var photos = jobData.photos || [];

      // Pattern de 9 tuiles avec 2 photos en positions 1 et 6, et mix riche de couleurs
      // P = photo, et les couleurs varient pour ne pas être monotone
      // Position 0 : c1 (foncé)
      // Position 1 : crème claire
      // Position 2 : c2Light
      // Position 3 : c1Light  
      // Position 4 : c2 (foncé) — centre
      // Position 5 : PHOTO 1
      // Position 6 : c2Light
      // Position 7 : c1Light
      // Position 8 : PHOTO 2... non on inverse
      // Pattern final : tuile, photo, tuile, tuile, photo, tuile, tuile, tuile, tuile
      var layout = [
        { type: 'color', bg: c1, title: titles[0] },          // 0 : c1 foncé
        { type: 'photo', img: photos[0], title: titles[1] },  // 1 : photo
        { type: 'color', bg: c2Light, title: titles[2] },     // 2 : c2 clair
        { type: 'color', bg: creme, title: titles[3] },       // 3 : crème
        { type: 'color', bg: c2, title: titles[4] },          // 4 : c2 foncé
        { type: 'color', bg: c1Light, title: titles[5] },     // 5 : c1 clair
        { type: 'photo', img: photos[1], title: titles[6] },  // 6 : photo
        { type: 'color', bg: c1, title: titles[7] },          // 7 : c1 foncé
        { type: 'color', bg: c2Light, title: titles[8] }      // 8 : c2 clair
      ];
      // Si pas de photos disponibles, fallback sur tuiles couleurs
      if (!photos[0]) layout[1] = { type: 'color', bg: c1Dark, title: titles[1] };
      if (!photos[1]) layout[6] = { type: 'color', bg: c2Dark, title: titles[6] };

      var tilesHtml = layout.map(function(tile) {
        if (tile.type === 'photo') {
          return '<div class="ig-tile ig-tile-photo">' +
                   '<img src="' + tile.img + '" alt="" loading="lazy">' +
                 '</div>';
        }
        var textColor = textColorFor(tile.bg);
        return '<div class="ig-tile" style="background:' + tile.bg + ';color:' + textColor + ';">' +
                 '<span class="ig-tile-text">' + esc(tile.title) + '</span>' +
               '</div>';
      }).join('');

      // Idées de Réels (boutons en bas), alterne couleurs pour avoir variété
      var reelIdeas = jobData.reels || [];
      var reelsHtml = reelIdeas.map(function(idea, i) {
        var bg, color;
        if (i % 4 === 0) { bg = c1; color = textColorFor(c1); }
        else if (i % 4 === 1) { bg = c2Light; color = espresso; }
        else if (i % 4 === 2) { bg = c2; color = textColorFor(c2); }
        else { bg = c1Light; color = espresso; }
        return '<button type="button" class="ig-reel-btn" style="background:' + bg + ';color:' + color + ';border-color:' + bg + ';">' +
                 '🎬 ' + esc(idea) +
               '</button>';
      }).join('');

      // Avatar emoji selon métier
      var emojiMap = {
        'lash': '👁️', 'ongles': '💅', 'maquillage': '💄', 'brow': '🪶',
        'esthetique': '💆', 'coiffure': '💇', 'formatrice': '🎓',
        'cosme': '🧴', 'vetements': '👗'
      };
      var emoji = emojiMap[selectedJob] || '✨';

      resultContainer.innerHTML =
        '<span class="miniquiz-step-label">Ton feed Instagram</span>' +
        '<h3>Voilà à quoi ça ressemble.</h3>' +
        '<p class="miniquiz-subtext">Aperçu indicatif de ton compte avec tes couleurs.</p>' +
        '<div class="ig-mockup">' +
          '<div class="ig-header">' +
            '<div class="ig-avatar" style="background:' + c2 + ';">' +
              '<span class="ig-avatar-emoji">' + emoji + '</span>' +
            '</div>' +
            '<div class="ig-info">' +
              '<div class="ig-handle">ton_compte</div>' +
              '<div class="ig-bio">' + esc(jobData.label) + ' · ' + esc(c1Name) + ' & ' + esc(c2Name) + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="ig-bio-line">' + emoji + ' ' + esc(jobData.label) + ' · Paris · RDV</div>' +
          '<div class="ig-stats">' +
            '<div><strong>312</strong><span>posts</span></div>' +
            '<div><strong>3.8k</strong><span>abonnés</span></div>' +
            '<div><strong>412</strong><span>abonnements</span></div>' +
          '</div>' +
          '<div class="ig-grid">' + tilesHtml + '</div>' +
        '</div>' +
        '<div class="ig-reels-block">' +
          '<div class="ig-reels-label">🎬 Idées de Réels pour ton compte</div>' +
          '<div class="ig-reels-list">' + reelsHtml + '</div>' +
        '</div>' +
        '<div class="ig-palette-line">' +
          '<span>Ta palette :</span>' +
          '<span class="ig-palette-dot" style="background:' + c1 + ';"></span>' +
          '<span class="ig-palette-dot" style="background:' + c2 + ';"></span>' +
          '<span class="ig-palette-names"><strong>' + esc(c1Name) + '</strong> + <strong>' + esc(c2Name) + '</strong></span>' +
        '</div>' +
        '<div class="miniquiz-result-actions">' +
          '<a href="https://thebeautymethod.fr/products/devenir-formatrice-accompagnement" class="btn btn-primary btn-large">Je veux structurer mon activité</a>' +
          '<button type="button" class="btn btn-ghost" data-mq-restart>Refaire le test</button>' +
        '</div>' +
        '<button type="button" class="miniquiz-restart" data-mq-back-colors>← Changer mes couleurs</button>';

      resultContainer.querySelectorAll('[data-mq-restart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          selectedJob = null;
          selectedColors = [];
          if (colorsContainer) {
            colorsContainer.querySelectorAll('.miniquiz-color').forEach(function(c) {
              c.classList.remove('selected');
            });
          }
          updateCounter();
          showStep('job');
        });
      });
      resultContainer.querySelectorAll('[data-mq-back-colors]').forEach(function(btn) {
        btn.addEventListener('click', function() { showStep('colors'); });
      });
    }
  }


  /* ==================== FORMS ==================== */
  function initForms() {
    document.querySelectorAll('[data-tbm-form]').forEach(function(form) {
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.dataset.originalText = submitBtn.textContent;

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var msgEl = form.querySelector('[data-form-message]');
        var subject = form.dataset.subject || 'Nouveau message TBM';

        var data = {};
        var formData = new FormData(form);
        formData.forEach(function(v, k) { data[k] = v; });
        data._subject = subject;

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Envoi en cours...';
        }
        if (msgEl) {
          msgEl.classList.remove('is-visible', 'success', 'error');
        }

        fetch('https://formsubmit.co/ajax/Thebtymethod@gmail.com', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(data)
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          if (msgEl) {
            msgEl.textContent = form.dataset.successMessage || 'Message envoyé !';
            msgEl.classList.add('is-visible', 'success');
          }
          form.reset();
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText || 'Envoyer';
          }
        })
        .catch(function() {
          if (msgEl) {
            msgEl.textContent = form.dataset.errorMessage || 'Écris-nous directement sur WhatsApp.';
            msgEl.classList.add('is-visible', 'error');
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.dataset.originalText || 'Envoyer';
          }
        });
      });
    });
  }

  /* ==================== ANIMATION DÉCLIC ==================== */
  function initDeclic() {
    var lines = document.querySelectorAll('[data-declic-line]');
    if (!lines.length) return;
    if (!('IntersectionObserver' in window)) {
      lines.forEach(function(l) { l.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var target = entry.target;
          var allLines = Array.prototype.slice.call(lines);
          var idx = allLines.indexOf(target);
          setTimeout(function() {
            target.classList.add('is-visible');
          }, idx * 350);
          io.unobserve(target);
        }
      });
    }, { threshold: 0.4 });
    lines.forEach(function(l) { io.observe(l); });
  }

  /* ==================== INIT ==================== */

  /* ==================== CAROUSELS GENERIQUES (FAQ + Testimonials) ==================== */
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
      var name = carousel.dataset.carousel;
      var track = carousel.querySelector('[data-carousel-track]');
      var slides = carousel.querySelectorAll('.carousel-slide');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dotsContainer = document.querySelector('[data-carousel-dots="' + name + '"]');
      if (!track || slides.length === 0) return;

      var current = 0;
      var total = slides.length;

      // Créer les dots
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        for (var i = 0; i < total; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'carousel-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('data-dot-idx', i);
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dotsContainer.appendChild(dot);
        }
        dotsContainer.querySelectorAll('[data-dot-idx]').forEach(function(d) {
          d.addEventListener('click', function() {
            goTo(parseInt(this.dataset.dotIdx, 10));
          });
        });
      }

      function goTo(index) {
        if (index < 0) index = total - 1;
        if (index >= total) index = 0;
        current = index;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        if (dotsContainer) {
          dotsContainer.querySelectorAll('.carousel-dot').forEach(function(d, i) {
            d.classList.toggle('is-active', i === current);
          });
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

      // Swipe tactile
      var startX = 0, isDown = false;
      track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; isDown = true; }, { passive: true });
      track.addEventListener('touchend', function(e) {
        if (!isDown) return;
        isDown = false;
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 40) {
          if (diff < 0) goTo(current + 1);
          else goTo(current - 1);
        }
      }, { passive: true });
    });
  }

  // ============================================================
  // V12 — GÉNÉRATEUR DE FEED INSTAGRAM (palettes premium)
  // ============================================================
  var FEEDGEN_PALETTES = {
    nude: ['#F4E4DC', '#E8C5B0', '#D4A88A', '#8B5A3C', '#FAF6F2'],
    bordeaux: ['#FFF1F1', '#F4C9D6', '#D85574', '#8F2A3C', '#3E2723']
  };
  var FEEDGEN_JOB_LABELS = {
    lash: 'Lash artiste',
    ongles: 'Prothésiste ongulaire',
    maquillage: 'Maquilleuse',
    brow: 'Brow artiste',
    esthetique: 'Esthéticienne',
    coiffure: 'Coiffeuse',
    formatrice: 'Formatrice',
    cosme: 'Marque cosmétique',
    vetements: 'Marque vêtements'
  };

  function initFeedgen() {
    var section = document.getElementById('feed-generator');
    if (!section) return;

    var stepJob = section.querySelector('[data-fg-step="job"]');
    var stepPalette = section.querySelector('[data-fg-step="palette"]');
    var stepResult = section.querySelector('[data-fg-step="result"]');
    var resultGrid = section.querySelector('[data-fg-result-grid]');
    var resultTitle = section.querySelector('[data-fg-result-title]');
    var backBtn = section.querySelector('[data-fg-back]');
    var restartBtn = section.querySelector('[data-fg-restart]');

    var selectedJob = null;
    var selectedPalette = null;

    function showStep(name) {
      [stepJob, stepPalette, stepResult].forEach(function(el) {
        if (el) el.classList.remove('active');
      });
      var target = section.querySelector('[data-fg-step="' + name + '"]');
      if (target) target.classList.add('active');
      try { section.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    // Étape 1 : sélection métier
    section.querySelectorAll('[data-fg-job]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        selectedJob = btn.getAttribute('data-fg-job');
        showStep('palette');
      });
    });

    // Bouton retour vers les métiers
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        selectedJob = null;
        selectedPalette = null;
        showStep('job');
      });
    }

    // Étape 2 : sélection palette
    section.querySelectorAll('[data-fg-palette]').forEach(function(card) {
      card.addEventListener('click', function() {
        selectedPalette = card.getAttribute('data-fg-palette');
        generateResult();
        showStep('result');
      });
    });

    // Bouton recommencer
    if (restartBtn) {
      restartBtn.addEventListener('click', function() {
        selectedJob = null;
        selectedPalette = null;
        showStep('job');
      });
    }

    function generateResult() {
      if (!resultGrid || !selectedPalette) return;
      var colors = FEEDGEN_PALETTES[selectedPalette];
      if (!colors) return;

      // Pattern pour le feed - alternance des couleurs pour un rendu Instagram crédible
      var pattern = [0, 2, 4, 1, 3, 0, 2, 4, 1];
      var tiles = resultGrid.querySelectorAll('[data-fg-tile]');
      tiles.forEach(function(tile, i) {
        var colorIdx = pattern[i % pattern.length];
        var color = colors[colorIdx];
        // Crée un dégradé subtil pour l'effet premium
        var nextIdx = (colorIdx + 1) % colors.length;
        var nextColor = colors[nextIdx];
        tile.style.background = 'linear-gradient(135deg, ' + color + ' 0%, ' + nextColor + ' 100%)';
      });

      // Met à jour le titre avec le métier sélectionné
      if (resultTitle && selectedJob) {
        var jobLabel = FEEDGEN_JOB_LABELS[selectedJob] || 'ton métier';
        var paletteLabel = selectedPalette === 'nude' ? 'Nude Rosé' : 'Bordeaux Signature';
        resultTitle.textContent = jobLabel + ' · ' + paletteLabel;
      }
    }
  }

  function init() {
    initHeroScrolls();
    initMobileMenu();
    initQuiz();
    initMiniQuiz();
    initFeedgen();
    initCarousels();
    initForms();
    initDeclic();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Feed button
// Bouton générer feed — scroll vers le miniquiz
document.querySelectorAll('[data-feed-open]').forEach(function(btn){
  btn.addEventListener('click', function(e){
    e.preventDefault();
    var target = document.getElementById('miniquiz') || document.querySelector('[data-miniquiz]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Petit délai puis activer le premier step
      setTimeout(function() {
        var firstStep = target.querySelector('.miniquiz-step');
        if (firstStep && !firstStep.classList.contains('active')) {
          firstStep.classList.add('active');
        }
      }, 600);
    }
  });
});

/* ============================================================
   MODAL FEED — V22
   ============================================================ */
function openFeedModal() {
  var modal = document.getElementById('mqFeedModal');
  if (!modal) return;
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  // Reset steps au step 1 (job)
  modal.querySelectorAll('.mq-step').forEach(function(s, i) {
    s.classList.toggle('active', i === 0);
  });
  modal.querySelectorAll('.mq-job-btn').forEach(function(b) { b.classList.remove('active'); });
  var res = modal.querySelector('[data-mq-result]');
  if (res) res.innerHTML = '';

  // Init le miniquiz du modal si pas encore fait
  // On utilise la même logique que initMiniQuiz mais sur le container modal
  var section = modal.querySelector('[data-miniquiz]');
  if (section && !section.dataset.mqInited) {
    section.dataset.mqInited = '1';
    // Forcer initMiniQuiz sur ce container
    initMiniQuizOnElement(section);
  }
}

function closeFeedModal() {
  var modal = document.getElementById('mqFeedModal');
  if (!modal) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// initMiniQuiz pour le modal (clone de initMiniQuiz mais dans un container spécifique)
function initMiniQuizOnElement(section) {
  var stepJob = section.querySelector('[data-mq-step="job"]');
  var stepColors = section.querySelector('[data-mq-step="colors"]');
  var stepResult = section.querySelector('[data-mq-step="result"]');
  var colorsContainer = section.querySelector('[data-mq-colors]');
  var counterEl = section.querySelector('[data-mq-counter]');
  var validateBtn = section.querySelector('[data-mq-validate]');
  var resultContainer = section.querySelector('[data-mq-result]');

  var selectedJob = null;
  var selectedColors = [];
  var currentColorPage = 0;

  function showStep(name) {
    [stepJob, stepColors, stepResult].forEach(function(s) {
      if (s) s.classList.remove('active');
    });
    if (name === 'job' && stepJob) stepJob.classList.add('active');
    if (name === 'colors' && stepColors) stepColors.classList.add('active');
    if (name === 'result' && stepResult) stepResult.classList.add('active');
    var box = section.closest('.mq-modal-panel');
    if (box) box.scrollTop = 0;
  }

  function buildColorPage(pageIdx) {
    if (!colorsContainer) return;
    colorsContainer.innerHTML = '';
    selectedColors = [];
    if (counterEl) counterEl.innerHTML = '<strong>0</strong> / 2 couleurs sélectionnées';
    if (validateBtn) validateBtn.disabled = true;

    var page = window.FEED_DATA.palettePages ? window.FEED_DATA.palettePages[pageIdx] : null;
    var colors = page ? page.colors : window.FEED_DATA.palette;

    // Label
    var lbl = colorsContainer.parentNode.querySelector('.mq-page-label');
    if (!lbl) { lbl = document.createElement('p'); lbl.className = 'mq-page-label'; colorsContainer.parentNode.insertBefore(lbl, colorsContainer); }
    lbl.textContent = page ? page.label : 'Choisis tes couleurs';

    // Switch btn
    var sw = colorsContainer.parentNode.querySelector('.mq-switch-btn');
    if (!sw) { sw = document.createElement('button'); sw.type = 'button'; sw.className = 'mq-switch-btn'; colorsContainer.parentNode.insertBefore(sw, colorsContainer.nextSibling); }
    sw.textContent = pageIdx === 0 ? 'Voir les couleurs vives →' : '← Voir les tons sobres';
    sw.onclick = function(e) { e.preventDefault(); currentColorPage = pageIdx === 0 ? 1 : 0; buildColorPage(currentColorPage); };

    colors.forEach(function(c) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'miniquiz-color';
      btn.style.background = c.hex;
      btn.title = c.name;
      btn.dataset.hex = c.hex;
      btn.addEventListener('click', function() {
        var hex = c.hex;
        if (btn.classList.contains('selected')) {
          btn.classList.remove('selected');
          selectedColors = selectedColors.filter(function(h) { return h !== hex; });
        } else {
          if (selectedColors.length >= 2) return;
          btn.classList.add('selected');
          selectedColors.push(hex);
        }
        if (counterEl) counterEl.innerHTML = '<strong>' + selectedColors.length + '</strong> / 2 couleurs sélectionnées';
        if (validateBtn) validateBtn.disabled = selectedColors.length < 2;
      });
      colorsContainer.appendChild(btn);
    });
  }

  // Jobs
  section.querySelectorAll('[data-mq-job]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      section.querySelectorAll('[data-mq-job]').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedJob = btn.dataset.mqJob;
      currentColorPage = 0;
      buildColorPage(0);
      showStep('colors');
    });
  });

  // Validate
  if (validateBtn) {
    validateBtn.addEventListener('click', function() {
      if (!selectedJob || selectedColors.length < 2) return;
      var jobData = window.FEED_DATA.jobs[selectedJob];
      if (!jobData || !resultContainer) return;

      var c1 = selectedColors[0], c2 = selectedColors[1];
      function getColorName(hex) {
        var pages = window.FEED_DATA.palettePages || [];
        for (var p = 0; p < pages.length; p++) {
          for (var i = 0; i < pages[p].colors.length; i++) {
            if (pages[p].colors[i].hex.toLowerCase() === hex.toLowerCase()) return pages[p].colors[i].name;
          }
        }
        for (var i = 0; i < window.FEED_DATA.palette.length; i++) {
          if (window.FEED_DATA.palette[i].hex.toLowerCase() === hex.toLowerCase()) return window.FEED_DATA.palette[i].name;
        }
        return hex;
      }

      function lighten(hex, t) {
        var n = parseInt(hex.replace('#',''),16);
        var r = Math.min(255,Math.round((n>>16)+(255-(n>>16))*t));
        var g = Math.min(255,Math.round(((n>>8)&0xff)+(255-((n>>8)&0xff))*t));
        var b = Math.min(255,Math.round((n&0xff)+(255-(n&0xff))*t));
        return '#'+[r,g,b].map(function(v){return v.toString(16).padStart(2,'0')}).join('');
      }

      function isLight(hex) {
        var n = parseInt(hex.replace('#',''),16);
        return ((n>>16)*299+((n>>8)&0xff)*587+(n&0xff)*114)/1000 > 155;
      }

      var c1l = lighten(c1, 0.3), c2l = lighten(c2, 0.25), c1d = lighten(c1, -0.2);
      var colorMap = [c1,c2,c1l,c2,c2l,c1,c2,c1l,c2];
      var photos = jobData.photos || [];
      var titles = (jobData.feedTitles || []).slice(0,9);

      var cells = '';
      for (var i = 0; i < 9; i++) {
        var usePhoto = (i === 0 || i === 5) && photos[i===0?0:1];
        var bg = usePhoto ? 'url('+photos[i===0?0:1]+') center/cover' : colorMap[i];
        var txt = isLight(colorMap[i]) ? 'rgba(42,24,16,0.75)' : 'rgba(255,255,255,0.9)';
        var style = usePhoto ? 'background:'+bg+';' : 'background:'+bg+';color:'+txt+';';
        cells += '<div class="mq-feed-cell" style="'+style+'">' + (usePhoto ? '' : '<span>'+esc(titles[i]||'')+'</span>') + '</div>';
      }

      var reelIdeas = jobData.reels || [];
      var reelHtml = reelIdeas.map(function(r) {
        return '<div class="mq-reel-idea" style="background:'+lighten(c1,0.25)+';color:'+( isLight(lighten(c1,0.25)) ? '#2A1810' : '#fff')+'">'+esc(r)+'</div>';
      }).join('');

      resultContainer.innerHTML = '<div class="mq-result-head"><h3 class="mq-step-title">Ton feed <em style="font-style:italic;color:var(--vieux-rose)">'+esc(jobData.label)+'</em></h3><p class="mq-step-sub">Aperçu avec tes couleurs '+esc(getColorName(c1))+' & '+esc(getColorName(c2))+'</p></div>'
        + '<div class="mq-ig-preview"><div class="ig-header"><div class="ig-avatar" style="background:'+c1+'"></div><div class="ig-bio-block"><div class="ig-handle">'+esc(jobData.handle)+'</div><div class="ig-tagline">'+esc(jobData.tagline)+'</div></div></div><div class="mq-feed-grid">'+cells+'</div></div>'
        + '<div class="mq-reels-section"><p class="mq-reels-title">Idées de Réels pour ton compte :</p><div class="mq-reels-grid">'+reelHtml+'</div></div>'
        + '<div class="mq-result-cta"><a href="#" data-quiz-open class="btn btn-primary" onclick="closeFeedModal()">Débloquer mon business →</a><button class="btn btn-secondary" onclick="closeFeedModal()">Fermer</button></div>';

      showStep('result');
    });
  }

  buildColorPage(0);

  function esc(s) {
    return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Boutons ouvrir feed modal
  document.querySelectorAll('[data-feed-open]').forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); openFeedModal(); });
  });
  // Fermer feed modal
  var closeBtn = document.getElementById('mqFeedClose');
  if (closeBtn) closeBtn.addEventListener('click', closeFeedModal);
  var overlay = document.getElementById('mqFeedModal');
  if (overlay) overlay.addEventListener('click', function(e) { if (e.target === overlay) closeFeedModal(); });
});

/* Slider avis pages produit */
var reviewsSliderIndex = 0;
function slideReviews(dir) {
  var sliders = document.querySelectorAll('.prod-reviews-slider');
  sliders.forEach(function(slider) {
    var cards = slider.querySelectorAll('.prod-review-card');
    if (!cards.length) return;
    reviewsSliderIndex = Math.max(0, Math.min(cards.length - 1, reviewsSliderIndex + dir));
    // Déplacer le premier card pour faire défiler tout le slider
    cards.forEach(function(card, i) {
      card.style.transform = 'translateX(' + ((i - reviewsSliderIndex) * 100) + '%)';
      card.style.transition = 'transform 0.3s ease';
    });
    // Mettre à jour les flèches
    slider.querySelectorAll('.reviews-prev').forEach(function(btn) {
      btn.style.opacity = reviewsSliderIndex === 0 ? '0.3' : '1';
    });
    slider.querySelectorAll('.reviews-next').forEach(function(btn) {
      btn.style.opacity = reviewsSliderIndex === cards.length-1 ? '0.3' : '1';
    });
  });
}

/* ============================================================
   DÉCLIC — animation au scroll
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  var lines = document.querySelectorAll('.declic-line');
  if (!lines.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var line = entry.target;
        var idx = parseInt(line.dataset.declic || '1');
        setTimeout(function() {
          line.classList.add('visible');
        }, (idx - 1) * 500);
        observer.unobserve(line);
      }
    });
  }, { threshold: 0.3 });

  lines.forEach(function(line) { observer.observe(line); });
});

/* ============================================================
   CERCLE PRIVÉ — bandeau discret
   ============================================================ */
(function() {
  var strip = document.getElementById('cercleStrip');
  var closeBtn = document.getElementById('cercleClose');
  if (!strip) return;

  // Ne pas afficher si déjà fermé dans cette session
  if (sessionStorage.getItem('cercle-closed')) return;

  // Apparaît après 8 secondes de navigation
  var timer = setTimeout(function() {
    strip.classList.add('visible');
    strip.setAttribute('aria-hidden', 'false');
  }, 8000);

  // Fermeture
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      strip.classList.remove('visible');
      sessionStorage.setItem('cercle-closed', '1');
      clearTimeout(timer);
    });
  }

  // Disparaît quand on clique sur le lien
  var link = strip.querySelector('.cercle-strip-link');
  if (link) {
    link.addEventListener('click', function() {
      sessionStorage.setItem('cercle-closed', '1');
    });
  }
})();

/* ============================================================
   SOLUTIONS SLIDER — V32
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  var track    = document.getElementById('solTrack');
  var prevBtn  = document.getElementById('solPrev');
  var nextBtn  = document.getElementById('solNext');
  var countEl  = document.getElementById('solCurrent');
  var dots     = document.querySelectorAll('.sol-dot');
  if (!track) return;

  var slides  = track.querySelectorAll('.sol-slide');
  var total   = slides.length;
  var current = 0;

  document.getElementById('solTotal').textContent = total;

  function goTo(idx) {
    current = Math.max(0, Math.min(total - 1, idx));
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    countEl.textContent = current + 1;
    // Dots
    dots.forEach(function(d, i) { d.classList.toggle('active', i === current); });
    // Flèches
    prevBtn.disabled = current === 0;
    nextBtn.disabled = current === total - 1;
  }

  prevBtn.addEventListener('click', function() { goTo(current - 1); });
  nextBtn.addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(d) {
    d.addEventListener('click', function() { goTo(parseInt(d.dataset.idx)); });
  });

  // Swipe tactile
  var startX = 0;
  track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function(e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
  });

  // Init
  goTo(0);
});

/* ── Reveal au scroll (V26) ───────────────────────────── */
(function(){
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init(){
    var selectors = [
      '.aud-title', '.aud-kicker', '.prod-section-kicker',
      '.tbm-formation-card', '.tbm-offer-card', '.tbm-quote-card',
      '.tbm-carousel-card', '.tbm-preview-card', '.tbm-price-grid > div',
      '.tbm-money-col', '.tbm-path4-step', '.reviews-ed-card'
    ];
    var els = document.querySelectorAll(selectors.join(','));
    if (!els.length) return;

    document.documentElement.classList.add('tbm-anim-ready');

    els.forEach(function(el, i){
      el.classList.add('tbm-anim');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
    });

    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el){ obs.observe(el); });

    // filet de sécurité : tout révéler après 3s quoi qu'il arrive
    setTimeout(function(){
      els.forEach(function(el){ el.classList.add('is-in'); });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ── Calculateur de CA (V27) ───────────────────────── */
(function(){
  function euro(n){
    return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 }).format(Math.round(n)) + ' \u20AC';
  }
  function initCalc(box){
    var priceInput = box.querySelector('[data-calc-price-input]');
    var qtyInput   = box.querySelector('[data-calc-qty-input]');
    var priceOut   = box.querySelector('[data-calc-price]');
    var qtyOut     = box.querySelector('[data-calc-qty]');
    var week       = box.querySelector('[data-calc-week]');
    var month      = box.querySelector('[data-calc-month]');
    var year       = box.querySelector('[data-calc-year]');
    if (!priceInput || !qtyInput) return;

    function update(){
      var p = parseFloat(priceInput.value) || 0;
      var q = parseFloat(qtyInput.value) || 0;
      var w = p * q;
      if (priceOut) priceOut.textContent = p;
      if (qtyOut)   qtyOut.textContent = q;
      if (week)  week.textContent  = euro(w);
      if (month) month.textContent = euro(w * 4);
      if (year)  year.textContent  = euro(w * 52);
    }
    priceInput.addEventListener('input', update);
    qtyInput.addEventListener('input', update);
    update();
  }
  function run(){
    var boxes = document.querySelectorAll('[data-calc]');
    for (var i = 0; i < boxes.length; i++) initCalc(boxes[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }
})();

/* ── Reveal au scroll ───────────────────────────── */
(function(){
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function init(){
    var sel = ['.aud-kicker','.tbm-sec-title','.tbm-form-row','.tbm-door','.tbm-teaser',
               '.tbm-offer-card','.tbm-step','.tbm-incl-item','.tbm-formule','.tbm-price-grid > div'];
    var els = document.querySelectorAll(sel.join(','));
    if (!els.length) return;
    document.documentElement.classList.add('tbm-anim-ready');
    Array.prototype.forEach.call(els, function(el, i){
      el.classList.add('tbm-anim');
      el.style.transitionDelay = ((i % 4) * 70) + 'ms';
    });
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    Array.prototype.forEach.call(els, function(el){ obs.observe(el); });
    setTimeout(function(){ Array.prototype.forEach.call(els, function(el){ el.classList.add('is-in'); }); }, 3000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ── Modal "pose ta question" ───────────────────────────── */
(function(){
  function run(){
    var modal = document.querySelector('[data-ask-modal]');
    if (!modal) return;
    var openBtns = document.querySelectorAll('[data-ask-open]');
    var closeBtn = modal.querySelector('[data-ask-close]');
    function open(){ modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close(){ modal.hidden = true; document.body.style.overflow = ''; }
    Array.prototype.forEach.call(openBtns, function(b){ b.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if (e.target === modal) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ── Points de carrousel ───────────────────────────── */
(function(){
  function link(track, dots){
    if (!track || !dots) return;
    var spans = dots.querySelectorAll('span');
    track.addEventListener('scroll', function(){
      var max = track.scrollWidth - track.clientWidth;
      var ratio = max > 0 ? track.scrollLeft / max : 0;
      var i = Math.round(ratio * (spans.length - 1));
      Array.prototype.forEach.call(spans, function(s, k){ s.classList.toggle('is-on', k === i); });
    }, { passive:true });
  }
  function run(){
    link(document.querySelector('.tbm-doors'), document.querySelector('[data-dots-for="doors"]'));
    link(document.querySelector('.tbm-form-list'), document.querySelector('[data-dots-for="formations"]'));
    link(document.querySelector('.tbm-teaser-row'), document.querySelector('[data-dots-for="teasers"]'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ── Pop-up offre du moment ───────────────────────────── */
(function(){
  function run(){
    var pop = document.querySelector('[data-pop]');
    if (!pop) return;
    try { if (sessionStorage.getItem('tbm-pop-seen')) return; } catch(e){}
    var closeBtn = pop.querySelector('[data-pop-close]');
    function close(){
      pop.hidden = true;
      document.body.style.overflow = '';
      try { sessionStorage.setItem('tbm-pop-seen', '1'); } catch(e){}
    }
    var shown = false;
    function show(){
      if (shown) return; shown = true;
      window.removeEventListener('scroll', onScroll);
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function onScroll(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.4) show();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(show, 20000);
    if (closeBtn) closeBtn.addEventListener('click', close);
    pop.addEventListener('click', function(e){ if (e.target === pop) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !pop.hidden) close(); });
    Array.prototype.forEach.call(pop.querySelectorAll('a'), function(a){ a.addEventListener('click', close); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
